import {
  useState,
  useContext,
  useMemo,
  useEffect,
  useCallback,
  useRef,
} from 'react'
import styled from 'styled-components'
import { IntakeContext } from 'context/IntakeContext'
import { Link, useSearchParams } from 'react-router-dom'

// @mui material components
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'

import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

// Soft UI Dashboard PRO React example components
import OnboardingLayout from 'components/LayoutContainers/OnboardingLayout'
import OnboardingNavbar from 'components/Navbars/OnboardingNavbar'
import OnboardingFooter from 'components/OnboardingFooter'

import WizardStep from 'components/WizardSteps/WizardStep'
import circleBG from 'assets/images/circles.svg'

//OnboardingSelectData
import { steps } from './data/steps'

import { callZapier } from 'utils/zapier/callZapier'
import { QuestionContainer } from './QuestionContainer'
import { useOnboarding } from './hooks/useOnboarding'

import { motion, AnimatePresence } from 'framer-motion'
// import { FieldFocusProvider } from 'context/FieldFocusContext'
import { useFieldFocus } from 'context/FieldFocusContext'

const StyledCard = styled(Card)`
  @keyframes fadeInLeft {
    0% {
      opacity: 0;
      transform: translateX(30%);
    }
    100% {
      opacity: 1;
      transform: translateX(0%);
    }
  }

  @keyframes fadeInRight {
    0% {
      opacity: 0;
      transform: translateX(-30%);
    }
    100% {
      opacity: 1;
      transform: translateX(0%);
    }
  }
`

const STEP_GROUPS = [
  'WizardStep (About Me)',
  'WizardStep (About Me)',
  'WizardStep (About Me)',
  'WizardStep (About Me)',
  'WizardStep (About Me)',
  'WizardStep (About Me)',
  'RetirementGoals',
  'Agency',
  'Agency',
  'Agency',
  'Employment',
  'Employment',
  'Employment',
  'Retirement',
  'Retirement',
  'TSP',
  'TSP',
  'TSP',
  'TSP',
  'TSP',
  'Healthcare',
  'Healthcare',
  'Healthcare',
  'Healthcare',
  'Healthcare',
]

const STEP_CONTENT = steps

export const Onboarding = ({ steps = STEP_CONTENT, customHandleNext }) => {
  const {
    activeStep,
    animate,
    direction,
    setAnimate,
    userNotification,
    StepComponent,
    stepComponentProps,
    required,
    handleBack,
    handleNext,
    handleSkipSection,
    isLastStep,
    isDisabled,
    additionalContext,
    intakeState,
  } = useOnboarding({ steps, customHandleNext })

  const normalise = (value) => ((value - 0) * 100) / (steps.length - 0)

  const seminarStyleAdjust =
    window.location.pathname === '/' ||
    window.location.pathname === '/seminar' ||
    window.location.pathname === '/walter-reed' ||
    window.location.pathname === '/event' ||
    window.location.pathname === '/complementary' ||
    window.location.pathname === '/full' ||
    window.location.pathname === '/ic' ||
    window.location.pathname === '/report' ||
    window.location.pathname === '/onboarding-flow' ||
    window.location.pathname === '/firststep'
      ? { xs: 'calc(100vh - 117px)', sm: 'calc(100vh - 125px)' }
      : { xs: 'calc(100vh - 119px)', sm: 'calc(100vh - 127px)' }

  const [fieldErrors, setFieldErrors] = useState({
    email: false,
    phone: false,
    tsp: false,
  })

  const { focusedFieldId, elementRef, helpFields, resetFieldFocus } =
    useFieldFocus()

  const [helpY, setHelpY] = useState(null)

  useEffect(() => {
    if (elementRef) {
      const rect = elementRef.getBoundingClientRect()
      const scrollY = window.scrollY || document.documentElement.scrollTop
      setHelpY(rect.top + scrollY)
    }
  }, [elementRef])

  return (
    <OnboardingLayout>
      {/* <DashboardNavbar /> */}
      {/* Shouldn't need this form wrapper */}
      {/* <form autoComplete="off"> */}
      <OnboardingNavbar />
      <Box sx={{ width: '100%', overflow: 'hidden', margin: 'auto' }}>
        <LinearProgress
          variant="determinate"
          value={normalise(activeStep + 1)}
          color="dark"
          sx={{
            height: '4px',
            overflow: 'hidden',
            borderRadius: '0px',
          }}
        />
      </Box>
      <Box
        sx={{
          minHeight: { ...seminarStyleAdjust },
        }}
      >
        <Grid
          container
          justifyContent="center"
          sx={{ backgroundColor: '#F9F9F9' }}
        >
          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              boxShadow: '4px 4px 25px -8px rgba(0, 0, 0, 0.2)',
            }}
          >
            <Box
              sx={{
                p: { xs: 1, sm: 3, md: 6 },
                background: '#fff',
                boxShadow: '4px 4px 25px -8px rgba(0, 0, 0, 0.2)',
                minHeight: { lg: 'calc(100vh - 127px)' },
                paddingBottom: { lg: '100px' },
                overflow: 'hidden',
              }}
            >
              {/* <Box
                mt={0}
                mb={1}
                px={2}
                textAlign="left"
                sx={{ display: { sm: 'none' } }}
              >
                <SoftBox mb={1}>
                  <SoftTypography variant="h3" fontWeight="bold">
                    Create Your PARCO Profile
                  </SoftTypography>
                </SoftBox>
              </Box> */}
              <StyledCard
                style={{
                  animation: `${
                    animate
                      ? direction == 'forward'
                        ? 'fadeInLeft 0.5s'
                        : 'fadeInRight 0.5s'
                      : ''
                  }`,
                  boxShadow: 'none',
                }}
                onAnimationEnd={() => {
                  setAnimate(false)
                }}
              >
                <QuestionContainer
                  StepComponent={StepComponent}
                  activeStep={activeStep}
                  handleNext={(e) => {
                    resetFieldFocus()
                    handleNext(e)
                  }}
                  handleSkipSection={handleSkipSection}
                  required={required}
                  userNotification={userNotification}
                  isLastStep={isLastStep}
                  handleBack={handleBack}
                  // isDisabled={isDisabled}
                  fieldErrors={fieldErrors}
                  setFieldErrors={setFieldErrors}
                  isDisabled={
                    typeof StepComponent.isInvalid === 'function'
                      ? StepComponent?.isInvalid({
                          ...intakeState,
                          fieldErrors,
                        })
                      : false
                  }
                  stepComponentProps={stepComponentProps}
                />
              </StyledCard>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              // backgroundImage: `url(${circleBG})`,
              bgcolor: '#00000000',
              backgroundPosition: 'center',
            }}
          >
            <Grid
              justifyContent="center"
              sx={{
                px: { xs: 0, md: 6 },
                pt: { xs: 0, lg: 12 },
                pb: { xs: 0, lg: 24 },
              }}
            >
              <Box sx={{ display: { xs: 'none', lg: 'flex' } }}>
                <AnimatePresence mode="sync">
                  {focusedFieldId && elementRef ? (
                    <motion.div
                      key={focusedFieldId}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.4 }}
                      style={{
                        position: 'absolute',
                        top: `${helpY}px`,
                        marginRight: '32px',
                      }}
                    >
                      <Typography variant="body1" color="#75787B" align="left">
                        {helpFields[focusedFieldId]}
                      </Typography>
                    </motion.div>
                  ) : null}
                </AnimatePresence>
              </Box>

              {additionalContext ? (
                <Card
                  sx={{
                    width: '80%',
                    margin: 'auto',
                    textAlign: 'left',
                    boxShadow: 1,
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <CardContent>
                    <Typography variant="h4" mb={2}>
                      {additionalContext.header}
                    </Typography>
                    {additionalContext.content}
                    {/* <div
                    style={{
                      background: 'rgba(184, 194, 242, 0.10)',
                      height: '180px',
                      width: '90%',
                      margin: 'auto',
                    }}
                  ></div> */}
                  </CardContent>
                </Card>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* <Footer /> */}
      <OnboardingFooter />
      {/* </form> */}
    </OnboardingLayout>
  )
}
